import * as angular from 'angular';
import customerBulkDeleteComponent from './customer-bulk-delete/customer-bulk-delete.component';
import customerBulkDeleteService from './customer-bulk-delete/customer-bulk-delete.service';
import { POINT_STATUSES, POINT_TYPES } from './customers.constants';
import customersRouter from './customers.router';
import customersService from './customers.service';
import fraudulentCustomersComponent from './fraudulent-customers/fraudulent-customers.component';
import fraudulentCustomersService from './fraudulent-customers/fraudulent-customers.service';
import unblockCustomersComponent from './unblock-customers/unblock-customers.component';
import unblockCustomersService from './unblock-customers/unblock-customers.service';

/** @constant {angular.module} */
const customersModule = angular
  .module('ec.opsCenter.customers', ['ec.opsCenter.common'])
  .config(customersRouter)
  .service('customersService', customersService)
  .service('customerBulkDeleteService', customerBulkDeleteService)
  .service('fraudulentCustomersService', fraudulentCustomersService)
  .service('unblockCustomersService', unblockCustomersService)
  .component('customerBulkDeleteComponent', customerBulkDeleteComponent)
  .component('fraudulentCustomersComponent', fraudulentCustomersComponent)
  .component('unblockCustomersComponent', unblockCustomersComponent)
  .factory('POINT_TYPES', POINT_TYPES)
  .factory('POINT_STATUSES', POINT_STATUSES).name;

export default customersModule;



// WEBPACK FOOTER //
// ./src/app/customers/customers.module.ts